import { Mode } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import {
    PHONE_VERIFICATION_MODAL_CLOSE,
    PHONE_VERIFICATION_MODAL_SHOW,
    PhoneVerificationModalCloseAction,
    PhoneVerificationModalShowAction,
} from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal.actions';

export interface PhoneVerificationModalState {
    opened: boolean;
    mode: Mode;
}

const initialState: PhoneVerificationModalState = {
    opened: false,
    mode: 'newuser',
};

type PhoneVerificationModalActions = PhoneVerificationModalShowAction
    | PhoneVerificationModalCloseAction;

const reducer = (state: PhoneVerificationModalState = initialState, action: PhoneVerificationModalActions) => {
    switch (action.type) {
        case PHONE_VERIFICATION_MODAL_SHOW:
            return {
                ...state,
                opened: true,
                mode: action.mode,

            };
        case PHONE_VERIFICATION_MODAL_CLOSE:
            return {
                ...state,
                opened: false,
            };
        default:
            return state;
    }
};

export default reducer;

export const getOpened = (state: PhoneVerificationModalState) => state.opened;
export const getMode = (state: PhoneVerificationModalState) => state.mode;
